import { useEffect, useState } from "react";
import { Link, NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { LogOut } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ADMIN_NAV = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/blog", label: "Blog Posts" },
  { to: "/admin/podcast", label: "Podcast Episodes" },
  { to: "/admin/talent", label: "Talent" },
  { to: "/admin/inquiries", label: "Inquiries" },
];

export const AdminLayout = () => {
  const [auth, setAuth] = useState(null); // null = checking, false = logged out, object = user
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => setAuth(res.data))
      .catch(() => setAuth(false));
  }, []);

  async function logout() {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setAuth(false);
    navigate("/admin/login");
  }

  if (auth === null) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center" data-testid="admin-loading">
        <p className="text-xs font-mono uppercase tracking-[.14em] text-[#555555]">Loading…</p>
      </div>
    );
  }

  if (auth === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="bg-[#fafafa] min-h-screen" data-testid="admin-layout">
      <header className="bg-white border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="admin-home-link">
            <img src="/brand/logo.webp" alt="#whatshesaidproject" className="h-8 w-auto" />
            <span className="text-xs font-mono uppercase tracking-[.14em] text-[#555555]">
              Studio
            </span>
          </Link>
          <div className="flex items-center gap-6">
            <span className="text-xs font-mono text-[#6b6b6b] hidden sm:inline">{auth.email}</span>
            <button
              type="button"
              onClick={logout}
              data-testid="admin-logout-button"
              className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[.14em] text-[#121212] hover:text-[#e02020] transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Log Out
            </button>
          </div>
        </div>
        <nav aria-label="Admin" className="bg-white border-t border-[#e5e5e5]">
          <div className="max-w-6xl mx-auto px-6 flex gap-6 overflow-x-auto">
            {ADMIN_NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) =>
                  `py-4 text-xs font-mono uppercase tracking-[.14em] whitespace-nowrap border-b-2 transition-colors ${
                    isActive
                      ? "border-[#e02020] text-[#121212]"
                      : "border-transparent text-[#555555] hover:text-[#121212]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
};
